import React, { useState } from "react";
import { styled } from "styled-components";

import { Close } from "../Proactive/Close";
import { AnnouncementPlacement, AnnouncementPosition } from "./types";

const Frame = styled.div({
  position: "absolute",
  width: 240,
  display: "flex",
  flexDirection: "column",
});

const CloseRow = styled.div({
  display: "flex",
  marginBottom: 8,
});

function frameStyle(
  placement: AnnouncementPlacement,
  position: AnnouncementPosition,
): React.CSSProperties {
  if (placement === "top") {
    return {
      bottom: "100%",
      marginBottom: 8,
      [position]: 0,
      alignItems: position === "left" ? "flex-start" : "flex-end",
    };
  }

  if (position === "right") {
    return {
      right: "100%",
      bottom: 0,
      marginRight: 8,
      alignItems: "flex-end",
    };
  }

  return {
    left: "100%",
    bottom: 0,
    marginLeft: 8,
    alignItems: "flex-start",
  };
}

interface ClosedChatFrameProps {
  placement: AnnouncementPlacement;
  position: AnnouncementPosition;
  onDismiss?: () => void;
  label: string;
  children: React.ReactNode;
}

export const ClosedChatFrame: React.FC<ClosedChatFrameProps> = ({
  placement,
  position,
  onDismiss,
  label,
  children,
}) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  const dismiss = () => {
    setDismissed(true);
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <Frame
      style={frameStyle(placement, position)}
      role="region"
      aria-label={label}
    >
      <CloseRow
        style={{
          justifyContent: position === "left" ? "flex-start" : "flex-end",
        }}
      >
        <Close onClick={dismiss} aria-label="Dismiss announcement" />
      </CloseRow>
      {children}
    </Frame>
  );
};
